import { Heading, Icon, Tappable } from "@trueskin-web/components"
import { arrowLongRightIcon } from "@trueskin-web/theme/icons/arrowLongRightIcon"

const ProductCard = ({
  title,
  description,
  image: Image,
  className,
  onClick,
}) => (
  <Tappable
    onClick={onClick}
    sx={{
      p: 3,
      display: "grid",
      gridTemplateColumns: "auto 1fr auto",
      alignItems: "center",
      gap: 3,
      border: "1px",
      borderColor: "brandNeutralsMediumGrey",
      borderRadius: "8px",
      width: "100%",
    }}
    className={className}
  >
    <Image
      sx={{
        width: 32,
        height: 56,
      }}
    />
    <div sx={{ fontSize: 1, lineHeight: "body" }}>
      <Heading
        as="h4"
        sx={{ fontSize: "inherit", fontWeight: "bold", lineHeight: "inherit" }}
      >
        {title}
      </Heading>
      <div sx={{ color: "textDark" }}>{description}</div>
    </div>
    <Icon icon={arrowLongRightIcon} sx={{ ml: "auto" }} asImage={true} />
  </Tappable>
)

export default ProductCard
